import React from "react";
import "./globals.css";

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar-content">
        <h1 className="navbar-title">Toronto ToneLab</h1>
      </div>
    </nav>
  );
};

export default Navbar;
